export const DO_GET_LIST = "DO_GET_LIST";
export const DO_GET_WISH_LIST = "DO_GET_WISH_LIST";
export const DO_GET_LIST_APPLY = "DO_GET_LIST_APPLY";
export const DO_GET_LIST_PLAN = "DO_GET_LIST_PLAN";
export const DO_GET_LIST_WORK = "DO_GET_LIST_WORK";
export const DO_GET_LIST_RESULT_EMPLOYMENT = "DO_GET_LIST_RESULT_EMPLOYMENT";
export const DO_GET_LIST_RESULT_SALARY = "DO_GET_LIST_RESULT_SALARY";
export const DO_GET_DETAIL = "DO_GET_DETAIL";
export const DO_APPLY_JOB = "DO_APPLY_JOB";
export const DO_CANCEL_APPLY_JOB = "DO_CANCEL_APPLY_JOB";
export const DO_APPLY_SEARCH = "DO_APPLY_SEARCH";
export const DO_GET_JOBCONTRACT = "DO_GET_JOBCONTRACT";
export const DO_GET_JOBARRANGEMENT = "DO_GET_JOBARRANGEMENT";
export const DO_JOB_TRANSFER_REQUEST = "DO_JOB_TRANSFER_REQUEST";
export const SHOW_JOBS = "SHOW_JOBS";
export const RESET_JOBS = "RESET_JOBS";
export const DO_APPLY_SEARCH_MAPS = "DO_APPLY_SEARCH_MAPS";
export const DO_RESET_DEFAULT = "DO_RESET_DEFAULT";

export default {
  DO_GET_LIST,
  DO_GET_WISH_LIST,
  DO_GET_LIST_APPLY,
  DO_GET_LIST_PLAN,
  DO_GET_LIST_WORK,
  DO_GET_LIST_RESULT_EMPLOYMENT,
  DO_GET_LIST_RESULT_SALARY,
  DO_GET_DETAIL,
  DO_APPLY_JOB,
  DO_CANCEL_APPLY_JOB,
  DO_APPLY_SEARCH,
  DO_GET_JOBCONTRACT,
  DO_GET_JOBARRANGEMENT,
  DO_JOB_TRANSFER_REQUEST,
  SHOW_JOBS,
  RESET_JOBS,
  DO_APPLY_SEARCH_MAPS,
  DO_RESET_DEFAULT,
};
